import Model from './model.js';

class Client extends Model {
  id = 0;
  name = '';
  // regions = [];
  // countries = [];
  isActive = true;
  hasApiAccess = true;
  shouldRefuseOrderWhenNoStock = false;

  mapForRequest() {
    return {
        name: this.name,
        isActive: this.isActive,
        shouldRefuseOrderWhenNoStock: this.shouldRefuseOrderWhenNoStock,
    };
  }
}

export default Client;
